import React, { useState } from "react";
import Textarea from "../../../components/FormComponents/Textarea";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import { toastSuccess } from "../../../utils/toastUtils";
import ExcelFieldsTable from "./ExcelFieldsTable";
import AddExcelFieldForm from "./AddExcelFieldForm";

const ExcelTemplateFieldsManager = ({ fieldsArr, setFieldsArr }) => {
  const [isJsonOpen, setJsonOpen] = useState(false);

  const handleAdd = (newField) => {
    setFieldsArr([...fieldsArr, newField]);
  };

  const handleCopyJson = () => {
    navigator.clipboard.writeText(JSON.stringify(fieldsArr, null, 2));
    toastSuccess("Copied to clipboard");
  };

  return (
    <>
      <div className="builder_form">
        <div className="d_flex space_between align_center">
          <label className="builder_label">Fields</label>
          <div className="d_flex gap_2">
            <ButtonActionIcon type="upload" onClick={() => setJsonOpen(true)} />
            <ButtonActionIcon type="content_copy" onClick={handleCopyJson} />
          </div>
        </div>

        <AddExcelFieldForm onAdd={handleAdd} />
      </div>

      <ExcelFieldsTable fieldsArr={fieldsArr} setFieldsArr={setFieldsArr} />

      <BuilderModal isOpen={isJsonOpen} onClose={() => setJsonOpen(false)} modalName="Upload JSON">
        <UploadFieldsJson setFieldsArr={setFieldsArr} />
      </BuilderModal>
    </>
  );
};

export default ExcelTemplateFieldsManager;

// Upload JSON modal
const UploadFieldsJson = ({ setFieldsArr }) => {
  const [input, setInput] = useState("");
  const [error, setError] = useState("");

  const handleUpload = () => {
    try {
      const parsed = JSON.parse(input);
      if (!Array.isArray(parsed)) return setError("Uploaded data must be an array");
      setFieldsArr(parsed);
    } catch {
      setError("Invalid JSON");
    }
  };

  return (
    <div className="builder_form">
      <Textarea value={input} onChange={(e) => setInput(e.target.value)} />
      <button onClick={handleUpload}>Upload</button>
      {error && <div className="error">{error}</div>}
    </div>
  );
};
